var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/TreeContextMenu/MenuLayout.tsx";
import { Menu } from '@mui/material';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var MenuLayout = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      coords = _ref.coords,
      onClose = _ref.onClose;
  return /*#__PURE__*/_jsx(Menu, {
    open: Boolean(coords),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    anchorReference: "anchorPosition" // eslint-disable-next-line no-undefined
    ,
    anchorPosition: coords ? {
      top: coords.y,
      left: coords.x
    } : undefined,
    onClose: onClose,
    children: children
  });
});
MenuLayout.displayName = 'MenuLayout';